import { Component, NgZone, OnInit } from '@angular/core';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './utils/services/authentication.service';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Capacitor } from '@capacitor/core';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
// Deeplink
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { RequestsService } from './utils/services/requests.service';
import { LoaderComponent } from './components/loader/loader.component';
import { UserService } from './utils/services/User.service';
import { apiUrls } from 'src/environments/environment';
import { AlertsComponent } from './components/alerts/alerts.component';
import { AppPurchase } from './utils/services/app-purchase';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  assetsApi = apiUrls.assetsApi;

  constructor(private menu: MenuController,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthenticationService,
    private screenOrientation: ScreenOrientation,
    private zone: NgZone,
    private request: RequestsService,
    private loader: LoaderComponent,
    public user: UserService,
    private navCtrl: NavController,
    private alert: AlertsComponent,
    private platform: Platform,
    private appPurchase: AppPurchase
  ) {
    this.initializeApp();
    const lang = translate.getBrowserLang();
    if (lang !== 'fr' && lang !== 'en') {
      translate.setDefaultLang('en');
    } else {
      translate.setDefaultLang(translate.getBrowserLang());
    }

    if (Capacitor.isNativePlatform()) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);

      this.platform.ready().then(async () => {
        this.appPurchase.registerProduct();
        this.appPurchase.storeRefresh();
      });
    }
  }

  async ngOnInit() {
    await this.authService.loadToken();
  }

  initializeApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(async () => {

        const url = new URL(event.url);
        const slug = url.pathname;
        const params = new URLSearchParams(url.search);

        if (slug) {
          if (params.has('code')) {
            const message = await this.translate.get('charging').toPromise();
            await this.loader.presentLoading(message + '...');
            this.request.checkQrcode(params.get('code'))
              .then(async (response) => {
                await this.loader.dismiss();
                this.router.navigateByUrl('/vinyl/' + response.id);
              })
              .catch(async (_) => {
                await this.loader.dismiss();
                this.router.navigateByUrl('/home');
              });
          } else {
            this.router.navigateByUrl('/home');
          }
        }
      });
    });
  }

  async closeMenu(id: string, url = null) {
    if (await this.user.getGuestUser() && url) {
      this.alert.alertFreeGuest();
    } else {
      this.menu.close(id);
      if (url) {
        this.router.navigateByUrl(url);
      }
    }
  }

  async logout(id: string) {
    this.authService.logout()
      .then(_ => {
        this.menu.close(id);
        this.navCtrl.navigateRoot('home');
      });
  }

  stopScanner() {
    document.body.classList.remove('qrscanner');
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
  }
}
